import { CantJoinModal } from '@/components/JoinGameSheet/CantJoinModal'
import { JoinGameSheet } from '@/components/JoinGameSheet/JoinGameSheet'
import { useStore } from '@/models'
import { Redirect, useNavigation, useRouter } from 'expo-router'

export default function () {
  const router = useRouter()
  const navigation = useNavigation()
  const { game } = useStore().game

  if (game?.gameId) {
    // Dismiss this modal screen if the user is on a game
    if (router.canDismiss()) {
      router.dismiss()
      return
    }

    if (navigation.canGoBack()) {
      return <Redirect href="/game" />
    }
    // If it can't show modal to dismiss
    return <CantJoinModal />
  }

  return <JoinGameSheet />
}
